// Vite only exposes VITE_* to the browser, which is exactly the boundary we
// want: anything secret lives in Supabase Edge Function secrets instead.

type AppEnv = 'local' | 'staging' | 'production';

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is missing. Copy .env.example to .env.local and fill it in, then run \`pnpm env:check\`.`,
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  appEnv: (import.meta.env.VITE_APP_ENV ?? 'local') as AppEnv,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  /** The Claude call extraction (extract-call) costs API credit, so it is off
   *  unless this is "on"; Read.ai action items fill the review instead. */
  aiExtraction: import.meta.env.VITE_AI_EXTRACTION === 'on',
};

export const isProduction = env.appEnv === 'production';
